import {BridgeComponent} from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
    static component = "authentication"

    connect() {
        super.connect();

        this.send("connect");
    }
}
